export interface AppointmentTypeFilterType {
  selectedTypes: server.dto.AppointmentType[]
}

export const getSortedTypes = (filter: AppointmentTypeFilterType) => {
  return [...filter.selectedTypes]
    .sort((a, b) => {
      // order by option, confirmed, cancelled
      const order = serverReference.appointmentTypes.map(type => type.value);
      const indexA = order.findIndex(value => value === a.value);
      const indexB = order.findIndex(value => value === b.value);
      return indexA - indexB;
    });
};

export const initialAppointmentTypeFilter: AppointmentTypeFilterType = {
  selectedTypes: []
};
